exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentDisplay{display:inline-block}.studentDisplay.nameAndAvatar .name{margin-left:.2em}.studentDisplay .academicLevelText{color:#888}.studentDisplay .editable{text-decoration:none;color:#555}.studentDisplay .textContent{display:inline-block;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/students/student_display.scss
// module id = 1400
// module chunks = 0